import TasksRatioModal from "./TasksRatioModal";

export default TasksRatioModal;